import cx from 'classnames2';
import moment from 'moment';
import React from 'react';

import Checkbox from '@mui/material/Checkbox';

import { IStoryListMessages, IUser } from '../../../../types';
import { purgeUrlCache } from '../../../utils';

import styles from './StoryRow.scss';

type IStoryRowProps = {
  title: string;
  author: string | IUser;
  createdAt: string;
  messages: IStoryListMessages;
  description?: string;
  thumbnail?: string;
  displayCheckBox?: boolean;
  displayAnalytics?: boolean;
  isCheckboxChecked?: boolean;
  analyticsData?: any;
  onClick?(): void;
  onCheckBoxClick?(): any;
};

export const StoryRow: React.FC<IStoryRowProps> = (props) => {
  const {
    thumbnail,
    title,
    author,
    createdAt,
    messages,
    onClick,
    displayCheckBox,
    displayAnalytics,
    analyticsData,
    isCheckboxChecked,
    onCheckBoxClick
  } = props;
  const formattedAuthor = typeof author === 'string' ? author : `${author.name.first} ${author.name.last}`;
  const image = purgeUrlCache(thumbnail);

  return (
    <tr className={styles.row} data-test="story-row">
      {displayCheckBox && (
        <td className={cx(styles.cell, 'no-sort')}>
          <a>
            <Checkbox checked={isCheckboxChecked} onChange={onCheckBoxClick} />
          </a>
        </td>
      )}
      <td className={cx(styles.cell, 'no-sort')}>
        <a>
          <div className={styles.image} style={{ backgroundImage: `url("${image}")` }} />
        </a>
      </td>
      <td className={cx(styles.header, 'no-sort')}>
        <a>
          <h4 className={styles.title}>{title}</h4>
        </a>
      </td>
      <td className={cx(styles.cell, 'no-sort')}>
        <a>
          <p className={styles.text}>{moment(createdAt).fromNow()}</p>
        </a>
      </td>
      <td className={cx(styles.cell, 'no-sort')}>
        <a>
          <p className={styles.text}>{formattedAuthor}</p>
        </a>
      </td>
      {displayAnalytics && (
        <td className={cx(styles.cell, 'no-sort')}>
          <a>
            <p className={styles.text}>{analyticsData.pageViews}</p>
          </a>
        </td>
      )}
      {displayAnalytics && (
        <td className={cx(styles.cell, 'no-sort')}>
          <a>
            <p className={styles.text}>{analyticsData.uniquePageViews}</p>
          </a>
        </td>
      )}
      {displayAnalytics && (
        <td className={cx(styles.cell, 'no-sort')}>
          <a>
            <p className={styles.text}>{analyticsData.averageTime}</p>
          </a>
        </td>
      )}
      {displayAnalytics && (
        <td className={cx(styles.cell, 'no-sort')}>
          <a>
            <p className={styles.text}>{analyticsData.shares}</p>
          </a>
        </td>
      )}
      <td className={cx(styles.cell, 'ui-table__actions')}>
        <a role="button" onClick={onClick} className="ui-button">
          {messages.view}
        </a>
      </td>
    </tr>
  );
};
